/** Small formatting helpers shared by server summaries and the web UI. */
/** "4:05" / "1:04:05" clock style for player readouts. */
export function formatClock(totalSec) {
    const sec = Math.max(0, Math.floor(totalSec));
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    const mm = h > 0 ? String(m).padStart(2, '0') : String(m);
    const ss = String(s).padStart(2, '0');
    return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
/** "12 min" / "1 hr 5 min" prose style for cards and stats. */
export function formatDuration(totalSec) {
    const min = Math.round(totalSec / 60);
    if (min < 1)
        return 'under a minute';
    if (min < 60)
        return `${min} min`;
    const h = Math.floor(min / 60);
    const rem = min % 60;
    return rem === 0 ? `${h} hr` : `${h} hr ${rem} min`;
}
//# sourceMappingURL=format.js.map